import { PlanContext } from "../../context"
import { PlanState } from "../../types"

interface Props {
    state: PlanState
}

export function NewYear({ state }: Props) {

    const { api, dispatch } = React.useContext(PlanContext)

    const { year, plans } = state

    if (plans.some(y => y === year)) {
        return null
    }

    const latest = plans.filter(y => y < year).sort((a, b) => b - a)[0]

    if (!latest) {
        return null
    }

    const setup = () => api.setupCurrentYear(latest).then(data => dispatch({ type: "load", data }))

    return <div className="new-year">
        Year {year} has not been initialised yet. <a onClick={setup}>Click here</a> to initialise from year {latest}.
    </div>

}
